<div class="card" [ngClass]="{
  'translucent-card': !ownsVehicle && vehicle.sold && !vehicle.ownsCurrentBid,
  'size-grid-mode': gridMode
}">
  <div class="card-body">
    <div [ngClass]="{ 'flex-card-grid': gridMode, 'flex-card-list': !gridMode }">
      <div class="vehicle-img-container">
        <div class="next-img" (click)="nextImg(vehicle)" *ngIf="vehicle.imgUrls && vehicle.imgUrls.length > 1">
          <i class="fa-solid fa-chevron-circle-right"></i>
        </div>
        <div class="prev-img" (click)="prevImg(vehicle)" *ngIf="vehicle.imgUrls && vehicle.imgUrls.length > 1">
          <i class="fa-solid fa-chevron-circle-left"></i>
        </div>
        <a [routerLink]="['../veiculos', slug, vehicle.id]" target="_blank"
          [ngClass]="{'no-img': !vehicle.imgUrls || vehicle.imgUrls.length <= 0}">
          <app-fipe-comparison-badge
            *ngIf="vehicle.fipeDiff !== undefined"
            variant="overlay"
            [fipeDiff]="vehicle.fipeDiff"
            [displayMode]="user?.fipeComparisonMode"
          />
          <div class="has-video-container" *ngIf="vehicle.hasVideo">
            <i class="fa-solid fa-video"></i>
          </div>

          <img *ngIf="vehicle.isArmored" class="armored-logo" src="assets/images/icons/blindado-logo.svg" alt="">

          <div class="new-car" *ngIf="vehicle.isNew && !ownsVehicle">Novidade</div>

          <div class="tag-container showroom" *ngIf="vehicle.destination === 'SHOWROOM'"><i class="app-icon-showroom"></i>SHOWROOM</div>
          <div class="card-gallery" *ngIf="vehicle.imgUrls && vehicle.imgUrls.length > 0">
            <img class="rounded card-image" src="{{img}}" [ngClass]="{'show': imgIndex == i}"
              *ngFor="let img of vehicleImages; let i = index" />
          </div>
          <div noImg class="no-img" *ngIf="!vehicle.imgUrls || vehicle.imgUrls.length <= 0">
            <i class="material-icons">photo_library</i>
          </div>
        </a>
      </div>
      <div class="vehicle-info">
        <a [routerLink]="['../veiculos', slug, vehicle.id]" target="_blank">
          <div class="row">
            <div class="col-10">
              <div class="name">
                {{ vehicle.make }} {{ vehicle.model }}
              </div>
            </div>
            <div class="col-2">
              <i class="fav-icon ml-2" (click)="toggleFavorite($event)" *ngIf="!ownsVehicle" [ngClass]="{
                          'app-icon-love': !vehicle.favorite, 'app-icon-love-alt': vehicle.favorite}">
              </i>
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-md-12">
              <div class="years">
                {{ vehicle.manufactureYear }}/{{ vehicle.modelYear }}
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="description">
                {{ vehicle.trim }}
              </div>
            </div>
          </div>
        </a>

        <div class="infos">
          <span>
            <i class="material-icons">maps</i>
            {{ vehicle.km | number }} km
          </span>

          <span *ngIf="vehicle.transmission !== undefined">
            <i class="material-icons">airline_seat_recline_normal</i>
            {{transmission}}
          </span>

          <span *ngIf="vehicle.fuel !== undefined">
            <i class="material-icons">local_gas_station</i>
            {{fuel}}
          </span>

          <div *ngIf="vehicle.reportStatus !== undefined">
            <span>
              <i class="material-icons">playlist_add_check</i>
              {{ reportStatus }}
            </span>
          </div>

        </div>

        <div class="row flex-grow-1 align-items-end mt-1">
          <div class="col-6 text-center" [ngClass]="{'mt-2': !vehicle.highestBid && !vehicle.hasBids}" *ngIf="(vehicle.highestBid || vehicle.currentPrice) && 
            !(vehicle.ownsAnyBid && vehicle.highestBid == vehicle.bidValue && !vehicle.sold) &&
            !(vehicle.ownsAnyBid && vehicle.highestBid != vehicle.bidValue && !vehicle.sold)">
            <div class="row">
              <div class="col-md-12 best-offer mb-1 mt-2" *ngIf="vehicle.highestBid || (vehicle.hasBids)">
                MAIOR OFERTA
              </div>
              <div class="col-12 best-offer-value">
                <span class="money">R$</span> {{ (vehicle.currentPrice ? vehicle.currentPrice : vehicle.highestBid) |
                number: '1.0-0': 'pt-BR'}}
              </div>
            </div>
          </div>
          <div class="col-1 " style="padding: 7px 0 4px;" [ngClass]="{'countdown-margin': (vehicle.ownsAnyBid && vehicle.highestBid != vehicle.bidValue && !vehicle.sold) ||
          (vehicle.ownsAnyBid && vehicle.highestBid == vehicle.bidValue && !vehicle.sold) ||
          (!vehicle.highestBid && !vehicle.currentPrice)}" *ngIf="gridMode">
            <div class="base-timer">
              <svg class="base-timer__svg" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
                <g class="base-timer__circle">
                  <circle class="base-timer__path-elapsed" cx="60" cy="60" r="50"></circle>
                  <path class="base-timer__path-remaining" [attr.stroke-dasharray]="contador?.circleDasharray"
                    [ngClass]="{'green': !contador?.danger, 'red': contador?.danger}" d="
                                M 60, 60
                                m -50, 0
                                a 50,50 0 1,0 100,0
                                a 50,50 0 1,0 -100,0
                              "></path>
                </g>
              </svg>
            </div>
          </div>
          <div class="col-5 timer-countdown" *ngIf="gridMode">
              <i class="material-icons">timer</i>
              {{contador?.days}}d {{contador?.hours | number:'2.0-0'}}h {{contador?.minutes |
              number:'2.0-0'}}m
              {{contador?.seconds | number:'2.0-0'}}s
          </div>
          <a class="bid-info" [routerLink]="['../veiculos', slug, vehicle.id]" target="_blank" [ngClass]="{
            'row-cast-off-danger': vehicle.ownsAnyBid && vehicle.highestBid != vehicle.bidValue && !vehicle.sold,
            'row-cast-off-current-bidder': vehicle.ownsAnyBid && vehicle.highestBid == vehicle.bidValue && !vehicle.sold,
            'row-cast-off-sold-another-person': (vehicle.sold && !vehicle.ownsCurrentBid),
            'flex-column my-2': gridMode
          }">
          <div [ngClass]="{ 'margin-y-1': gridMode }">
            <div class="title">
              <ng-container *ngIf="
                  vehicle.ownsAnyBid && vehicle.highestBid != vehicle.bidValue && !vehicle.sold
                ">
                <i class="app-icon-tag"></i> COBRIRAM A SUA OFERTA
              </ng-container>
              <ng-container *ngIf="
                  vehicle.ownsAnyBid && vehicle.highestBid == vehicle.bidValue
                ">
                <i class="app-icon-tag"></i> SUA ÚLTIMA OFERTA
              </ng-container>
              <ng-container *ngIf="vehicle.sold">
                <i class="app-icon-hammer"></i> OUTRA REVENDA ARREMATOU
                POR
              </ng-container>
            </div>
            <div class="value" *ngIf="vehicle.ownsAnyBid">
              <span class="symbol">R$</span>
              {{ vehicle.highestBid | number: "1.2-2" }}
            </div>
            <div class="infos" *ngIf="vehicle.currentBidDealerName && !vehicle.ownsCurrentBid && user?.hasPermissionMenuVender()">
              Oferta de: {{vehicle.currentBidDealerName}}
            </div>
          </div>
          <div class="buttons-container" [ngClass]="{ 'grid-buttons-container': gridMode }">
            <div>
              <ng-container *ngIf="vehicle.ownsAnyBid && vehicle.highestBid == vehicle.bidValue">
                <i class="material-icons">check_circle</i> Você está arrematando!
              </ng-container>
            </div>
            <ng-container
              *ngIf="vehicle.ownsAnyBid && vehicle.bidValue && vehicle.highestBid != vehicle.bidValue && !vehicle.sold">
              Sua oferta: R${{ vehicle.bidValue | number: "1.2-2" }}
            </ng-container>
            <ng-container
              *ngIf="!vehicle.ownsCurrentBid && !vehicle.hasPersonalizedOffer && !ownsVehicle && user && user.isDealer()"
              >
              <div ngbDropdown placement="bottom-left" #makeBidFastQuoteDropdown="ngbDropdown">
                <span class="makebid-button btn btn-primary btn-rounded" *ngIf="!vehicle.ownsAnyBid"
                  ngbDropdownToggle
                  (click)="makeBidFastQuoteDropdown.open(); $event.stopPropagation(); $event.preventDefault()"
                  [ngClass]="{ 'countdown-margin': !gridMode && !vehicle.highestBid && !vehicle.currentPrice}">
                  FAÇA SUA OFERTA
                </span>
                <span class="btn btn-primary btn-rounded mr-2" style="margin-top: 3px;"
                  *ngIf="vehicle.ownsAnyBid && vehicle.highestBid != vehicle.bidValue && !vehicle.sold"
                  ngbDropdownToggle
                  (click)="makeBidFastQuoteDropdown.open(); $event.stopPropagation(); $event.preventDefault()">
                  NOVA OFERTA
                </span>
                <div ngbDropdownMenu class="dropdown-menu make-bid-panel" (click)="$event.preventDefault()">
                  <ng-container
                    *ngIf="(vehicle.target == 'EXCLUSIVE_GROUPS' && vehicle.exclusiveDealer == true) || vehicle.target != 'EXCLUSIVE_GROUPS'">
                    <app-make-bid-fast-quote (click)="$event.preventDefault()" [vehicle]="vehicle" [fromCard]="true"
                      [disableConfirmationModal]="true"></app-make-bid-fast-quote>
                  </ng-container>
                  <ng-container *ngIf="vehicle.target == 'EXCLUSIVE_GROUPS' && vehicle.exclusiveDealer == false">
                    <app-exclusive-group-request [vehicle]="vehicle" [isListCard]="true">
                    </app-exclusive-group-request>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </div>
        </a>
      </div>

        <div *ngIf="!gridMode" class="row align-items-end mb-3">
        <div class="col-1" style="padding: 7px 20px 4px;">
            <div class="base-timer">
              <svg class="base-timer__svg" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
                <g class="base-timer__circle">
                  <circle class="base-timer__path-elapsed" cx="60" cy="60" r="50"></circle>
                  <path class="base-timer__path-remaining" [attr.stroke-dasharray]="contador?.circleDasharray"
                    [ngClass]="{'green': !contador?.danger, 'red': contador?.danger}" d="
                                M 60, 60
                                m -50, 0
                                a 50,50 0 1,0 100,0
                                a 50,50 0 1,0 -100,0
                              "></path>
                </g>
              </svg>
            </div>
          </div>
          <div class="col-5 timer-countdown">
            
              <i class="material-icons">timer</i>
              {{contador?.days}}d {{contador?.hours | number:'2.0-0'}}h {{contador?.minutes |
              number:'2.0-0'}}m
              {{contador?.seconds | number:'2.0-0'}}s
            
          </div>
        </div>
        <div class="row flex-grow-1 align-items-center mb-2">
          <div class="col-3">
            <div class="img-oemDealer">
              <img [src]="vehicle.oemDealerImgUrl">
            </div>
          </div>
          <div class="oemDealer-info col-8">
            <div class="row">
              <div class="col-12 oemDealer-name pt-1">
                {{vehicle.oemDealerName}}
              </div>
              <div class="col-12 localization">
                <span><i class="material-icons" style="color: #CBCED1">room</i> {{vehicle.city + ' / ' +
                  vehicle.uf}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>